module.exports = __webpack_public_path__ + "img/event_pending.6cb9ff87.png";